<div
  class="border rounded-md px-2 relative border-color w-full inline-flex items-center"
  [ngClass]="{ 'error-border': control?.errorState(), 'bg-stone-100 opacity-50': control?.isDisabled() }"
  (click)="onContainerClick($event)"
>
  <div class="py-[9px] relative flex-1" [ngClass]="{ 'pb-1 pt-3.5': !!label }">
    @if (!!label) {
      <span
        class="absolute transition-all duration-300 ease-in-out origin-top-left font-semibold text-sm"
        [ngClass]="{
          'label -translate-y-1/2 text-ctr-gray': !shouldLabelFloat(),
          'top-0 scale-75 translate-y-0 text-ctr': shouldLabelFloat(),
          'text-secondary-20': control?.focused(),
          'error-color': control?.errorState(),
        }"
      >
        {{ label }}
      </span>
    }
    <div class="flex gap-1 w-full items-center">
      @if (!label || shouldLabelFloat()) {
        <ng-content select="[ctrPrefix]"></ng-content>
      }
      <div class="flex-1">
        <ng-content></ng-content>
      </div>
    </div>
  </div>

  <ng-content select="[ctrSuffix]"></ng-content>
</div>
